module.exports = __webpack_public_path__ + "static/lucaswork8-98f818dc61a2ad3c8984e464824a105d.jpg";